export interface Step {
  title: string,
  url: string,
}

interface Steps {
  CREATE_ACCOUNT: Step,
  VERIFY: Step,
  PERSONAL_INFO: Step,
  SELECT_PLAN: Step,
  CUSTOMIZE: Step,
  CHECKOUT: Step,
}

const STEPS: Steps = {
  CREATE_ACCOUNT: { title: 'Create Login', url: '/create-account' },
  VERIFY: { title: 'Verify', url: '/create-account/verify' },
  PERSONAL_INFO: { title: 'Personal Info', url: '/create-account/personal-info' },
  SELECT_PLAN: { title: 'Select Plan', url: '/preview-customize/plan-selection' },
  CUSTOMIZE: { title: 'Customize', url: '/preview-customize/?q=1' },
  CHECKOUT: { title: 'Checkout', url: '/preview-customize/checkout' },
};

const PROGRESS_NODES = [
  STEPS.CREATE_ACCOUNT,
  STEPS.VERIFY,
  STEPS.PERSONAL_INFO,
];

const FULL_MEMBER_CUSTOMIZE_NODES = [
  STEPS.SELECT_PLAN,
  STEPS.CUSTOMIZE,
  STEPS.CHECKOUT,
];

export {
  STEPS,
  PROGRESS_NODES,
  FULL_MEMBER_CUSTOMIZE_NODES,
};
